import loadable from '@loadable/component';

const NewsletterPage = loadable(() => import('./newsletters_page_marketo'));

export default function() {
  const routeConfig = {
    path: '/newsletters',
    component: NewsletterPage,
    exact: true,
    strict: true,
    chunk: 'newslettersPage'
  };

  return routeConfig;
}
